import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginDialogComponent } from 'src/app/shared/components/login-dialog/login-dialog.component';
@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    public router: Router,
  ) {
  }
  ngOnInit(): void {
    this.openLoginDialog();
  }
  public openLoginDialog(): void {
    sessionStorage.setItem('module', 'splash');

    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'login-dialog';
    dialogConfig.data='splash';
    dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(LoginDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
